import { Column } from 'src/shared/components/Semantic/all'
import { HowToSection } from './components/HowToSection'
import { WhatWeAreSection } from './components/WhatWeAreSection'
import { WhyKlayderSection } from './components/QuoteRequestSection'
import { FreeSamplesSection } from './components/FreeSamplesSection'
import { HomeHero } from './components/Hero'
import { SaraDemoSection } from './components/SaraDemoSection'
import { FAQSection } from './components/FAQSection'
import {
  FadeInOnMount,
  FadeInSection,
} from 'src/shared/components/FadeInSection'
import { Footer } from 'src/shared/components/Footer'
import { TestimonialSection } from './components/TestimonialSection'
import { BookMeetingSection } from './components/BookMeetingSection'

export const HomePage = () => {
  return (
    <Column className="relative">
      <FadeInOnMount>
        <HomeHero />
      </FadeInOnMount>

      <Column className="relative w-full gap-16 bg-white px-4 py-16 md:gap-24 md:px-6 md:py-24">
        <FadeInSection>
          <HowToSection />
        </FadeInSection>

        <FadeInSection>
          <WhatWeAreSection />
        </FadeInSection>

        <FadeInSection>
          <WhyKlayderSection />
        </FadeInSection>

        <FadeInSection>
          <SaraDemoSection />
        </FadeInSection>

        <FadeInSection>
          <FreeSamplesSection />
        </FadeInSection>

        <FadeInSection>
          <TestimonialSection />
        </FadeInSection>

        <FadeInSection>
          <FAQSection />
        </FadeInSection>

        <FadeInSection>
          <BookMeetingSection />
        </FadeInSection>
      </Column>

      <FadeInSection>
        <Footer />
      </FadeInSection>
    </Column>
  )
}
